import { render } from "./DashboardProductTables.vue?vue&type=template&id=48d2b5ca&scoped=true"
import script from "./DashboardProductTables.vue?vue&type=script&lang=js"
export * from "./DashboardProductTables.vue?vue&type=script&lang=js"

import "./DashboardProductTables.vue?vue&type=style&index=0&id=48d2b5ca&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d2b5ca"]])

export default __exports__